var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":_vm.to,"custom":""},scopedSlots:_vm._u([{key:"default",fn:function({ href, route, navigate, isActive, isExactActive }){return [_c('b-navbar-item',{attrs:{"href":href}},[_vm._t("default",function(){return [_vm._v(_vm._s(route.name)+" ")]})],2)]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }